import { render } from "./SubcriptionExpiredModal.vue?vue&type=template&id=9aa55174&scoped=true"
import script from "./SubcriptionExpiredModal.vue?vue&type=script&lang=js"
export * from "./SubcriptionExpiredModal.vue?vue&type=script&lang=js"

import "./SubcriptionExpiredModal.vue?vue&type=style&index=0&id=9aa55174&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9aa55174"]])

export default __exports__